import { Box } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { AffordabilitySection } from "web_myplann/Inspiration/Components/AffordabilitySection";
import { DownPaymentSection } from "web_myplann/Inspiration/Components/DownPaymentSection";
import { ExpensesNudge } from "web_myplann/Inspiration/Components/ExpensesNudge";
import { InspirationTimeline } from "web_myplann/Inspiration/Components/InspirationTimeline";
import { RentVsOwnComparison } from "web_myplann/Inspiration/Components/RentVsOwnComparison";
import { OWN_HOME_TIMELINE_STEPS } from "web_myplann/Inspiration/constants";
import type { OwnHomeContext } from "web_myplann/Inspiration/Utils/ownHomeMath";

type Props = {
	context: OwnHomeContext;
	onEditAffordability: () => void;
	onAddExpenses: () => void;
};

export const OwnHomeResult: FC<Props> = ({
	context,
	onEditAffordability,
	onAddExpenses,
}) => {
	const { t } = useResource();

	const showDownPayment =
		context.state === "full" && (context.savingsGap ?? 0) > 0;

	return (
		<>
			<Box mt={0.8}>
				<RentVsOwnComparison context={context} />
			</Box>
			<Box mt={0.8}>
				<AffordabilitySection context={context} onEdit={onEditAffordability} />
			</Box>
			{context.state === "affordability" && (
				<Box mt={0.8}>
					<ExpensesNudge onClick={onAddExpenses} />
				</Box>
			)}
			{showDownPayment && (
				<Box mt={0.8}>
					<DownPaymentSection context={context} />
				</Box>
			)}
			<Box mt={0.8}>
				<InspirationTimeline
					title={t(Resources.Inspiration.OwnHome.Result.timelineTitle)}
					steps={OWN_HOME_TIMELINE_STEPS}
				/>
			</Box>
		</>
	);
};
